<template>
  <v-container grid-list-lg class="pa-0 ma-0" fluid v-if="getPermissaoToken('ACESSO_AUDITORIA')">

    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12 class="pt-0 pb-0">
        <v-card flat :style="!$vuetify.breakpoint.smAndDown ? 'padding-left: 90px; padding-right: 90px;' : 'padding-top: 15px; padding-bottom: 10px;'">
          <v-card-title class="pt-0 pb-0">
            <v-layout row wrap :align-center="$vuetify.breakpoint.smAndUp" :align-content-center="$vuetify.breakpoint.smAndDown">
            
              <v-flex xs12 sm3 md2 lg1 :style="filtroComputed.filtroDataString() == 'Data' ? !$vuetify.breakpoint.smAndDown ? 'margin-right: 0px;' : '' : !$vuetify.breakpoint.smAndDown ? 'margin-right: 2px;' : ''">
                <v-menu
                  v-model="filtro.data.opened"
                  :close-on-content-click="false"
                  offset-y
                  transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroDataString() == 'Data'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtroDataString()}}</v-btn>
                  <v-card>
                    <v-layout row wrap >
                      <v-flex xs5 class="ma-3 text-xs-center">
                        <b><span class="primary--text">Data</span></b>
                        <br><br>
                        <v-date-picker
                          id="filtroDataInicioDatePicker"
                          v-model="filtro.data.datepicker"
                          header-color="primary"
                          locale="pt-br"
                          :max="(new Date()).toISOString().substring(0, 10)"
                        ></v-date-picker>
                      </v-flex>
                    </v-layout>
                    <v-card-actions>
                      <v-layout>
                        <v-btn
                          @click="filtroFunctions().limparData()"
                          color="primary"
                          flat
                          small
                        >Limpar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          @click="filtroFunctions().aplicarData()"
                          color="primary"
                          flat
                          small
                        >Aplicar</v-btn>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm11 md6 lg4>
                <transition name="fade">
                  <v-flex xs1 v-if="!filtro.pesquisa.opened">
                    <v-btn
                      v-if="!filtro.pesquisa.opened"
                      @click="filtroFunctions().abrirFiltroPesquisa()"
                      color="primary"
                      round
                      outline
                      v-on="on"
                      icon
                    ><v-icon>search</v-icon></v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="filtro.pesquisa.conteudo"
                      prepend-icon="search"
                      @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                      @blur="filtroFunctions().fecharFiltroPesquisa()"
                      label="Busca"
                      hint="Informe descrição, usuário, nº solicitação ou cliente"
                      autofocus
                      clearable
                    ></v-text-field>
                  </v-flex>
                </transition>
              </v-flex>
            
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <v-container class="ml-82 mr-82 pa-24">
      <v-flex xs12 >
        <v-layout row wrap class="scrollflex">
          <v-flex xs12 class="scrollflexcontent">
            <v-list class="pa-0" two-line>
              <v-toolbar height="56" color="primary">
                <v-flex xs4>
                  <v-toolbar-title class="subheading white--text">Descrição</v-toolbar-title>
                </v-flex>
                <v-flex xs2 text-xs-center>
                  <v-toolbar-title class="subheading white--text">Usuário</v-toolbar-title>
                </v-flex>
                <v-flex xs2 text-xs-center>
                  <v-toolbar-title class="subheading white--text">Data/Hora</v-toolbar-title>
                </v-flex>
                <v-flex xs2 text-xs-center>
                  <v-toolbar-title class="subheading white--text">Solicitação</v-toolbar-title>
                </v-flex>
                <v-flex xs2 text-xs-center>
                  <v-toolbar-title class="subheading white--text">Cliente</v-toolbar-title>
                </v-flex>
              </v-toolbar>
              <div v-for="auditoria in registrosPaginados" :key="auditoria.id">
                <v-divider></v-divider>
                <v-list-tile  :id="'auditoria-' + auditoria.id" avatar :style="`margin-top: ${auditoria.descricao.length/6}px; margin-bottom: ${auditoria.descricao.length/6}px;`">
                  <v-flex xs4>
                    <v-list-tile-sub-title :id="'auditoria-' + auditoria.id + '-descricao'" class="themeGrey--text" style="white-space: pre-wrap;" v-html="auditoria.descricao"></v-list-tile-sub-title>
                  </v-flex>
                  <v-flex xs2 text-xs-center>
                    <v-list-tile-sub-title :id="'auditoria-' + auditoria.id + '-usuario'" class="themeGrey--text" style="white-space: pre-wrap;" v-html="auditoria.usuario"></v-list-tile-sub-title>
                  </v-flex>
                  <v-flex xs2 text-xs-center>
                    <v-list-tile-sub-title :id="'auditoria-' + auditoria.id + '-dataHora'" class="themeGrey--text" style="white-space: pre-wrap;" v-html="toLocaleString(auditoria.dataCriacao)"></v-list-tile-sub-title>
                  </v-flex>
                  <v-flex xs2 text-xs-center>
                    <v-list-tile-sub-title :id="'auditoria-' + auditoria.id + '-protocolo'" class="themeGrey--text" style="white-space: pre-wrap;" v-html="auditoria.protocolo"></v-list-tile-sub-title>
                  </v-flex>
                  <v-flex xs2 text-xs-center>
                    <v-list-tile-sub-title :id="'auditoria-' + auditoria.id + '-cliente'" class="themeGrey--text" style="white-space: pre-wrap;" v-html="auditoria.cliente"></v-list-tile-sub-title>
                  </v-flex>
                </v-list-tile>
              </div>
            </v-list>
            <br>
            <v-flex text-xs-center>
              <v-pagination
                v-model="paginacao.atual"
                :length="paginacao.numPaginas"
                :total-visible="7"
                circle
              ></v-pagination>
            </v-flex>
            <br>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
  </v-container>
</template>

<script>
import axios from 'axios';
import CustomFormat from '@/helpers/custom-format';
import permissoes from '@/helpers/permissoes';
import usuarioHelper from '@/helpers/usuario-logado.js';

export default {
  name: 'Auditoria',
  data () {
    return {
      on: null,
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        },
        data: {
          opened: false,
          data: null,
          aplicado: {
            data: null,
            formatado: {
              data: null
            }
          }
        }
      },
      paginacao: {
        atual: 1,
        numPaginas: 1
      },
      registros: [],
      registrosFiltro: [],
      registrosPaginados: []
    }
  },
  computed: {
    filtroComputed: function() {
      const self = this;
      return {
        filtroDataString: function() {
          if (self.filtro.data.aplicado.data) {
            return `${self.filtro.data.aplicado.formatado.data}`;
          } else {
            return 'Data';
          }
        }
      }
    }
  },
  watch: {
    "paginacao.atual": function(val) {
      this.filtroFunctions().aplicarFiltros(val);
    },
    "filtro.data.aplicado.data": function(val) {
      this.filtro.data.aplicado.formatado.data = CustomFormat.parseDateToFormatedStringWithMonthName(val);
    },
    "filtro.pesquisa.conteudo": function(val) {
      this.filtroFunctions().aplicarFiltros();
    }
  },
  mounted: function() {
    this.buscaRegistrosAuditoria();
  },
  methods: {
    buscaRegistrosAuditoria: function () {
      const self = this;
      self.$store.commit('startLoading');
      axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/buscaRegistrosAuditoria`, {
        
          headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
      })
      .then((response) => {
        self.registros = response.data;
        self.registrosFiltro = self.registros;
        self.filtroFunctions().aplicarFiltros();
        self.$store.commit('endLoading');
      })
      .catch(err => {
        self.$store.commit('endLoading');
      });
    },
    salvaRegistroAuditoria: function (auditoriaModel) {
      const self = this;
      axios.post(`${process.env.URL_QUESTIONARIOMS}/v1/salvaRegistroAuditoria`, auditoriaModel, {

          headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
      })
    },
    toLocaleString: function (datetime) {
      return CustomFormat.toLocaleDateTimeString(datetime);
    },
    getPermissaoToken: function(requested) {
      const permissionObj = permissoes;
      return eval("permissionObj.verificaPermissao(permissionObj.SolicitacaoConsulta." + requested + ")");
    },
    filtroFunctions: function() {
      const self = this;
      return {
        aplicarFiltros: function (paginaAtual) {
          const pesquisa = self.filtro.pesquisa.conteudo;
          const data = self.filtro.data.aplicado.data;
          
          self.registrosFiltro = self.registros;

          if(data) {
            self.registrosFiltro = self.registrosFiltro.filter((auditoria) => {
              return auditoria.dataCriacao.substring(0, 10) == data;
            });
          }
          if (pesquisa && pesquisa.length > 0) {
            self.registrosFiltro = self.registrosFiltro.filter((auditoria) => {
              return  auditoria.descricao.toUpperCase().includes(pesquisa.toUpperCase())
                      ||
                      auditoria.usuario.toUpperCase().includes(pesquisa.toUpperCase())
                      ||
                      auditoria.protocolo.toUpperCase().includes(pesquisa.toUpperCase())
                      ||
                      auditoria.cliente.toUpperCase().includes(pesquisa.toUpperCase());
            });
          }
          this.aplicarPaginacao(paginaAtual);
        },
        aplicarPaginacao: function(paginaAtual) {
          self.paginacao.numPaginas = Math.ceil(self.registrosFiltro.length/10);
          self.paginacao.atual = paginaAtual ? paginaAtual : 1;
          self.registrosPaginados = [];

          let count = (self.paginacao.atual * 10) - 10;
          let limiteMin = (self.paginacao.atual * 10) - 10;
          let limiteMax = limiteMin + 10;

          if (self.paginacao.atual <= self.paginacao.numPaginas) {
            for (let i = limiteMin; i < limiteMax; i++) {
              if (self.registrosFiltro[i]) {
                self.registrosPaginados.push(self.registrosFiltro[i]);
              }
              limiteMin++;
            }
          }

          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        },
        aplicarData: function() {
          self.filtro.data.aplicado.data = self.filtro.data.datepicker;
          self.filtro.data.opened = false;
          this.aplicarFiltros();
        },
        limparData: function() {
          self.filtro.data.aplicado.data = null;
          self.filtro.data.aplicado.formatado.data = null;
          self.filtro.data.datepicker = null;
          self.filtro.data.opened = false;
          this.aplicarFiltros();
        },
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (!self.filtro.pesquisa.conteudo || self.filtro.pesquisa.conteudo == '') {
            self.filtro.pesquisa.opened = false;
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.scrollflex {
  overflow-x: auto;
}
.scrollflexcontent {
  min-width: 800px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/auditoria/Auditoria.vue